"use client";
import React, { useEffect, useState } from "react";
import { motion } from "motion/react";
import { Projects } from "@/components/utils/data";
import ProjectDetails from "../ProjectDetails";

interface ProjectProps {
  name: string;
}

export default function ProjectsReusable({
  projects,
}: {
  projects: ProjectProps;
}) {
  const [projectIndex, setProjectIndex] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    setLoading(true);
    const filterProject = Projects.findIndex(
      (project) => project.name === projects.name,
    );
    setProjectIndex(filterProject);
    setLoading(false);
  }, [projects]);

  if (loading) {
    return (
      <div className="min-h-screen min-w-full flex flex-col justify-center items-center bg-linear-to-br from-gray-50 via-white to-gray-100 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
        <div className="relative flex flex-col items-center gap-8">
          {/* Animated Dots */}
          <div className="flex items-center justify-center gap-3">
            {[0, 1, 2].map((index) => (
              <motion.div
                key={index}
                className="w-4 h-4 rounded-full bg-linear-to-tr from-sky-600 to-indigo-800"
                animate={{
                  scale: [1, 1.5, 1],
                  opacity: [0.5, 1, 0.5],
                }}
                transition={{
                  duration: 1.2,
                  repeat: Infinity,
                  delay: index * 0.2,
                  ease: [0.4, 0, 0.2, 1],
                }}
              />
            ))}
          </div>

          {/* Loading Text */}
          <motion.p
            className="font-outfit font-medium bg-linear-to-r from-sky-600 to-indigo-800 bg-clip-text text-transparent"
            animate={{
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            Loading project...
          </motion.p>

          {/* Backdrop Glow */}
          <motion.div
            className="absolute -z-10 w-64 h-64 rounded-full bg-linear-to-r from-purple-300/20 via-pink-300/20 to-orange-300/20 blur-3xl"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.3, 0.5, 0.3],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        </div>
      </div>
    );
  }

  if (projectIndex === null) {
    return (
      <div className="min-h-screen min-w-full flex flex-col justify-center items-center">
        <h1 className="text-2xl font-bold font-recoleta text-center">
          Project not found
        </h1>
        <p className="text-lg font-outfit text-center">
          Please check the project name
        </p>
      </div>
    );
  }
  return <ProjectDetails project={Projects[projectIndex]} />;
}
